import slideToggle from '../src/slide_toggle'

$(() => {
  slideToggle.init('.js-manabiya-categories-toggle')
  slideToggle.init('.js-flow-step-toggle')
})
